// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px, .news-block > h2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

ion-header {
  z-index: 1000;
}

.inner-content.min-height {
  min-height: 600px;
}

.back-btn {
  position: initial;
}
.back-btn ion-icon {
  min-width: 20px;
}

ng-select {
  font-family: "Roboto-Regular";
}

::ng-deep .ng-select .ng-select-container .ng-arrow-wrapper {
  margin: 0;
}
::ng-deep .ng-select .ng-select-container .ng-arrow-wrapper .ng-arrow {
  display: block !important;
}

.back-button-block {
  width: 103%;
}
.back-button-block.fixed {
  border-bottom: 1px solid #DDDEE3;
  position: fixed;
  z-index: 2000;
  background: #F8F9FE;
  padding: 30px 0;
}

.no-contacts-list {
  color: var(--vl-black-font);
  font-family: "Roboto-Regular";
  font-size: 16px;
  text-align: center;
  margin-top: 18px;
}
.no-contacts-list.from-modal {
  padding: 0 16px;
}

.select-wrapper .select-label {
  color: var(--vl-black-font);
  font-family: "Roboto-Regular";
  font-size: 16px;
}
.select-wrapper ng-select {
  margin: 16px 0;
}

h2 {
  margin-bottom: 20px;
}
h2.from-modal {
  padding-left: 30px !important;
  margin-bottom: 0;
}

.news-block {
  margin-top: 17px;
}
.news-block > h2 {
  margin-bottom: 16px;
}
.news-block ion-list {
  padding: 0;
  flex-direction: column;
}
.news-block ion-list.margin-top {
  margin-top: 145px;
}
.news-block ion-item {
  margin: 0;
  --padding-start: 0;
  --border-color: #DDDEE3 !important;
  padding-bottom: 4px;
  --border-radius: 8px;
}
.news-block ion-item.from-modal {
  --border-radius: 0;
}
.news-block ion-item a {
  display: flex;
  align-items: center;
  width: 100%;
}
.news-block ion-item ion-label {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 52px;
}
.news-block ion-item ion-label span {
  font-weight: 400 !important;
  font-size: 0.9rem;
  color: var(--vl-black);
  font-family: "Roboto-Regular";
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
}
.news-block ion-item ion-label .phone-wrapper {
  display: flex;
  align-items: baseline;
  flex-direction: row;
}
.news-block ion-item ion-label .phone-wrapper .text {
  font-style: italic;
  margin: 0;
}
.news-block ion-item ion-label .text, .news-block ion-item ion-label .phone-string {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--vl-black-font);
  font-family: "Roboto-Regular";
  line-height: 1.1rem;
}
.news-block ion-item vl-icon {
  width: auto;
  height: auto;
  color: #a7a7ae;
}
.news-block ion-item vl-icon.contact-icon {
  margin: 0 16px;
}
.news-block ion-item vl-icon.next-icon {
  margin: 0 4px;
}
.news-block ion-item vl-icon.next-icon ::ng-deep svg {
  stroke: var(--vl-red);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/support-wrapper/contact-us/contact-us.page.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,aAAA;AA0DF;;AAtDE;EACE,iBAAA;AAyDJ;;AArDA;EACE,iBAAA;AAwDF;AAtDE;EACE,eAAA;AAwDJ;;AApDA;EACE,6BDbe;ACoEjB;;AAjDI;EACE,SAAA;AAoDN;AAnDM;EACE,yBAAA;AAqDR;;AA/CA;EACE,WAAA;AAkDF;AAjDE;EACE,gCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAmDJ;;AA/CA;EACE,2BAAA;EACA,6BDzCe;EC0Cf,eAAA;EACA,kBAAA;EACA,gBAAA;AAkDF;AAjDE;EACE,eAAA;AAmDJ;;AA9CE;EACE,2BAAA;EACA,6BDrDa;ECsDb,eAAA;AAiDJ;AA/CE;EACE,cAAA;AAiDJ;;AA5CA;EACE,mBAAA;AA+CF;AA9CE;EACE,6BAAA;EACA,gBAAA;AAgDJ;;AA5CA;EACE,gBAAA;AA+CF;AA7CE;EAEE,mBDzEa;ACuHjB;AAzCE;EACE,UAAA;EACA,sBAAA;AA2CJ;AA1CI;EACE,iBAAA;AA4CN;AAxCE;EACE,SAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,oBAAA;AA0CJ;AAzCI;EACE,kBAAA;AA2CN;AAzCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA2CN;AAxCI;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AA0CN;AAxCM;EACE,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BDpHS;ECqHT,mBAAA;EACA,aAAA;EACA,sBAAA;AA0CR;AAvCM;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AAyCR;AAxCQ;EACE,kBAAA;EACA,SAAA;AA0CV;AAtCM;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,6BDxIS;ECyIT,mBAAA;AAwCR;AApCI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAsCN;AArCM;EACE,cAAA;AAuCR;AArCM;EACE,aAAA;AAuCR;AAtCQ;EACE,qBAAA;AAwCV","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\nion-header {\n  z-index: 1000;\n}\n\n.inner-content {\n  &.min-height {\n    min-height: 600px;\n  }\n}\n\n.back-btn {\n  position: initial;\n\n  ion-icon {\n    min-width: 20px;\n  }\n}\n\nng-select {\n  font-family: $roboto-regular;\n}\n\n::ng-deep {\n  .ng-select \n  .ng-select-container {\n    .ng-arrow-wrapper {\n      margin: 0;\n      .ng-arrow {\n        display: block !important;\n      }\n    }\n  }\n}\n\n.back-button-block {\n  width: 103%;\n  &.fixed {\n    border-bottom: 1px solid #DDDEE3;\n    position: fixed;\n    z-index: 2000;\n    background: #F8F9FE;\n    padding: 30px 0;\n  }\n}\n\n.no-contacts-list {\n  color: var(--vl-black-font);\n  font-family: $roboto-regular;\n  font-size: 16px;\n  text-align: center;\n  margin-top: 18px;\n  &.from-modal { \n    padding: 0 16px;\n  }\n}\n\n.select-wrapper {\n  .select-label {\n    color: var(--vl-black-font);\n    font-family: $roboto-regular;\n    font-size: 16px;\n  }\n  ng-select {\n    margin: 16px 0;\n  }\n}\n\n\nh2 {\n  margin-bottom: 20px;\n  &.from-modal {\n    padding-left: 30px !important;\n    margin-bottom: 0;\n  }\n}\n\n.news-block {\n  margin-top: 17px;\n\n  & > h2 {\n    @extend .px-16px;\n    margin-bottom: $global-padding;\n  }\n\n  //background: #DDDEE3;\n\n  ion-list {\n    padding: 0;\n    flex-direction: column;\n    &.margin-top {\n      margin-top: 145px;\n    }\n  }\n\n  ion-item {\n    margin: 0;\n    --padding-start: 0;\n    --border-color: #DDDEE3 !important;\n    padding-bottom: 4px;\n    --border-radius: 8px;\n    &.from-modal {\n      --border-radius: 0;\n    }\n    a{\n      display: flex;\n      align-items: center;\n      width: 100%;\n    }\n\n    ion-label {\n      padding: 0;\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      flex: 1 1 auto;\n      min-height: 52px;\n\n      span {\n        font-weight: 400 !important;\n        font-size: 0.9rem;\n        color: var(--vl-black);\n        font-family: $roboto-regular;\n        line-height: 1.4rem;\n        display: flex;\n        flex-direction: column;\n      }\n\n      .phone-wrapper {\n        display: flex;\n        align-items: baseline;\n        flex-direction: row;\n        .text {\n          font-style: italic;\n          margin: 0;\n        }\n      }\n\n      .text, .phone-string {\n        font-size: 0.75rem;\n        font-weight: 400;\n        color: var(--vl-black-font);\n        font-family: $roboto-regular;\n        line-height: 1.1rem;\n      }\n    }\n\n    vl-icon {\n      width: auto;\n      height: auto;\n      color: #a7a7ae;\n      &.contact-icon{\n        margin: 0 16px;\n      }\n      &.next-icon{\n        margin: 0 4px;\n        ::ng-deep svg {\n          stroke: var(--vl-red);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
